import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-card-type-2',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './card-type-2.component.html',
    styleUrl: './card-type-2.component.scss',
})
export class CardType2Component implements OnInit {
    @Input() image!: string;
    @Input() gaPrefix!: string;
    @Input() title!: string;
    @Input() description!: string;
    @Input() buttonText: string;
    @Output() buttonClick = new EventEmitter<void>();
    ga: any = {
        id: '',
        label: '',
        category: 'JC3 Button Click',
    };

    ngOnInit(): void {
        let slug = this.title?.toLowerCase()?.replaceAll(' ', '_');
        this.ga.id = this.gaPrefix + slug + '_button_jc3_click';
        this.ga.label = this.gaPrefix.replaceAll('_', ' ');
    }

    onButtonClick() {
        this.buttonClick.emit();
    }
}
